var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default", null, { isVisible: _vm.isVisible }),
      _c(
        "span",
        {
          ref: "revealButton",
          class: [
            "reveal-password tooltipped tooltipped-n tooltipped-no-delay",
            { "reveal-password-visible": _vm.isVisible },
          ],
          attrs: {
            type: "button",
            "aria-label": _vm.isVisible ? "Hide password" : "Show password",
          },
          on: { click: _vm.onClick },
        },
        [
          _c("span", {
            attrs: {
              "aria-label": _vm.isVisible ? "Hide password" : "Show password",
            },
          }),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }